var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramPeople48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./People48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pictogramPeople48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Original",
    transform: "translate(6.000000, 9.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "person-2",
    transform: "translate(23.000000, 8.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "head",
    fill: "#FFFFFF",
    cx: 9.5,
    cy: 6.5,
    r: 5.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75,31.25 L18.25,31.25 L18.25,22 C18.25,16.8830066 14.3236437,12.75 9.5,12.75 C4.6763563,12.75 0.75,16.8830066 0.75,22 L0.75,31.25 Z",
    id: "body",
    fill: "#FFCC00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "person-1",
    transform: "translate(6.000000, 8.000000)",
    fill: "#FFFFFF",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "head",
    cx: 9.5,
    cy: 6.5,
    r: 5.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75,31.25 L18.25,31.25 L18.25,22 C18.25,16.8830066 14.3236437,12.75 9.5,12.75 C4.6763563,12.75 0.75,16.8830066 0.75,22 L0.75,31.25 Z",
    id: "body"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramPeople48);
export default __webpack_public_path__ + "static/media/pictogramPeople48.7c29cb19c2ad0804d17d11b8d68fd1bb.svg";
export { ForwardRef as ReactComponent };